module.exports = __webpack_public_path__ + "static/media/violet.999a4025.png";